enum IncomeVerificationIncomeSourceTypeEnum {
    // employment
    Employment = 'employment',
    Freelance = 'freelance',
    BusinessOwnership = 'business ownership',
}

export default IncomeVerificationIncomeSourceTypeEnum;
